import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '../components';

const NavMenuLabel = ({ children, ...rest }) => (
  <Text {...rest} noMargin bold>
    {children}
  </Text>
);

NavMenuLabel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default NavMenuLabel;
